import { render } from "./PluginEditor.vue?vue&type=template&id=74344006"
import script from "./PluginEditor.vue?vue&type=script&lang=js"
export * from "./PluginEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__